export function normalizeSymbolSearchScope(segment, exchange) {
  const normalizedSegment = String(segment || 'all').toLowerCase();
  if (normalizedSegment === 'commodity') {
    return { segment: 'commodity', exchange: 'MCX' };
  }
  return { segment: normalizedSegment, exchange: exchange || 'all' };
}
